import React from 'react';

import {  Card,Button,Select, Input, Table, Checkbox, Icon} from 'antd';


import { Text,Box, Flex} from '../../shared/components';

import TextArea from 'antd/lib/input/TextArea';


class factura extends React.Component {
  constructor(props, context) {
    super(props, context);
  
  }
 

  render() {

    const columns_1 = [
      {
        title: 'Ud.',
        dataIndex: 'ud',
        key: 'ud',
      },
      {
        title: 'Artículo',
        dataIndex: 'articulo',
        key: 'articulo',
      },
      {
        title: 'Precio Ud.',
        dataIndex: 'precioud',
        key: 'precioud',
      },
      {
        title: 'Bruto',
        dataIndex: 'bruto',
        key: 'bruto',
      },
      {
        title: 'Imp',
        dataIndex: 'imp',
        key: 'imp',
      },
      {
        title: 'Neto',
        dataIndex: 'neto',
        key: 'neto',
      },
      {
        title: 'Acciones',
        dataIndex: 'acciones',
        key: 'acciones',
        render: (acciones) => (
            <Text>
              <a>{acciones.split(' ')[0] + ' ' + acciones.split(' ')[1] + ' ' + acciones.split(' ')[2] }</a>  
            </Text>
            ),
    
      },
      
    ];
   
    const dataSource_1 = [
        {
          key: '1',
          ud: '1',
          articulo: 'Afflelou OAH6161 Negro C1 54 0 (Afflelou Leon)',
          precioud:'25.20€',
          bruto:'25.20€',
          imp:'16%',
          neto:'30.00€',
          acciones: 'Editar | Eliminar',
        },
        {
          key: '2',
          ud: '1',
          articulo: 'Afflelou OAH6161 Negro C1 54 0 (Afflelou Leon)',
          precioud:'40.00€',
          bruto:'46.40€',
          imp:'16%',
          neto:'46.40€',
          acciones: 'Editar | Eliminar',
        },
        {
            key: '3',
            ud: '1',
            articulo: 'Afflelou OAH6161 Negro C1 54 0 (Afflelou Leon)',
            precioud:'40.00€',
            bruto:'46.40€',
            imp:'16%',
            neto:'46.40€',
            acciones: 'Editar | Eliminar',
        },
        {
          key: '4',
          ud: '1',
          articulo: 'Afflelou OAH6161 Negro C1 54 0 (Afflelou Leon)',
          precioud:'40.00€',
          bruto:'48.40€',
          imp:'21%',
          neto:'48.40€',
          acciones: 'Editar | Eliminar',
        },
       
      ];
  
    const { titulo } = this.props;

    return (
      
        <Box>
        <Card style={{height: "753px",
             marginTop:"42px", marginLeft:"24px", width:"70%"}}  title={<Text marginLeft="8px" fontSize="19px" fontWeight="600" translationId="facturar.datos_de_facturacion"/>}> 
            <Box marginLeft="8px" > 
            <Text color=" #3E3E3C" fontSize="16px" style={{fontWeight:600}} translationId="facturar.datos_basicos"/>
           
           
            <Flex marginTop="16px">
            <Box flex={3}>
            <Text translationId="factura.nombre" />
            </Box>
            <Box flex={1} marginRight="24px">
            <Text marginLeft="16px" translationId="factura.dni"/>
            </Box>

            </Flex>

            <Flex marginTop="8px">
            <Box flex={3}>
            <Input addonAfter={<Icon type="user" />}   size="large"/>
            </Box>
            <Box flex={1} marginRight="24px" >
            <Input style={{marginLeft:"16px"}} size="large"/>
            </Box>
            </Flex>

            <Text color="#3E3E3C" fontSize="16px" marginTop="16px" style={{fontWeight:600}} translationId="factura.contacto"/>
            <Flex marginTop="16px">
            <Box flex={3}>
            <Text translationId="factura.email"/>
            </Box>
            <Box flex={1} marginRight="24px">
            <Text marginLeft="16px" translationId="factura.telefono"/>
            </Box>
            </Flex>

            <Flex marginTop="8px">
            <Box flex={3}>
            <Input size="large"/>
            </Box>
            <Box flex={1} marginRight="24px" >
            <Input style={{marginLeft:"16px"}} size="large"/>
            </Box>
            </Flex>

            <Text color="#3E3E3C" fontSize="16px" marginTop="16px" style={{fontWeight:600}} translationId="factura.direccion_facturacion"/>
            <Flex marginTop="16px">
            <Box flex={3}>
            <Text translationId="factura.direccion"/>
            </Box>
            <Box flex={1} marginRight="24px">
            <Text marginLeft="16px" translationId="factura.cp"/>
            </Box>
            </Flex>
            <Flex marginTop="8px">
            <Box flex={3}>
            <Input size="large"/>
            </Box>
            <Box flex={1} marginRight="24px" >
            <Input style={{marginLeft:"16px"}} size="large"/>
            </Box>
            </Flex>
            <Flex marginTop="16px">
            <Box flex={1}>
            <Text translationId="factura.provincia"/>
            </Box>
            <Box flex={1} marginRight="24px">
            <Text marginLeft="16px" translationId="factura.poblacion"/>
            </Box>
            </Flex>
            <Flex marginTop="8px">
            <Box flex={1}>
            <Select size="large" style={{width:"100%"}} placeholder="Selecciones la provincia"/>
            </Box>
            <Box flex={1} marginRight="24px" >
            <Input size="large"  style={{ marginLeft:"16px"}}/>
            </Box>
            </Flex>


  

            <Text color="#3E3E3C" fontSize="16px" marginTop="16px" style={{fontWeight:600}} translationId="factura.informacion_para_el_cliente"/>
            <Flex marginTop="16px">
            <Text translationId="factura.pie_de_la_factura"/>
            </Flex>
            <Flex marginRight="8px">
            <TextArea  placeholder="Escriba aquí..." style={{marginTop:"8px",  height:"182px"}}/>
            </Flex>
            </Box>       
         </Card>
                <style>{`.table-factura{ 
                    border-color:white 1px solid !important;
                    margin-right:"16px";
                }
                .table-factura th:nth-child(2){ 
                    width:41%;
                }`
                }  
                </style>
               <Card style={{height: "auto", marginBottom:"169px",
               width: "70%", marginTop:"16px", marginLeft:"24px"}}
               title={<Flex justifyContent="space-between"><Text marginLeft="8px" color="rgba(0,0,0,0.85)" fontSize="19px" fontWeight="600" >Nombre del cliente</Text> <Text color="rgba(0,0,0,0.85)" fontSize="19px" fontWeight="600" style={{marginRight:"8px"}}>Precio</Text></Flex>}
               > 
               <Box marginLeft="8px" marginRight="8px">
               <Table className="table-factura" columns={columns_1} dataSource={dataSource_1} pagination={false} />
               <Button type="dashed" block style={{width:"100%", height:"40px",marginBottom:"80px",marginTop:"12px"}}>
                    <Text translationId="factura.añadir_linea"/>
                </Button>
      
                </Box>
            </Card>
            <Box marginTop="168px">
            </Box>
            <Box style={{width:"100%", height:"72px", background:"#FFFFFF", position:"fixed", bottom:0, zIndex:30, boxShadow:"0 -2px 8px 0 rgba(0,0,0,0.15)"}}>
            <Flex mt="16px" marginLeft="16px"> 
            <Checkbox style={{marginTop:"16px", marginLeft:"0.7%"}} ><Text translationId="generico.enviar_por_email"/></Checkbox>
            <Button style={{marginLeft:"44%", width:"95px", height:"40px"}} ><Text translationId="generico.cancelar"/></Button>
            <Button style={{marginLeft:"8px", width:"95px", height:"40px", backgroundColor: "#049BDD", color:"white"} }><Text translationId="factura.facturar"/></Button>
            </Flex>
            </Box>

            </Box>
    );
  }
}



export default factura;


